import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
    Stack
} from "@mui/material";
import { useTranslation } from "react-i18next";
import React from "react";

import BoltIcon from '@mui/icons-material/Bolt';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import PaymentsIcon from '@mui/icons-material/Payments';
import Co2Icon from '@mui/icons-material/Co2';
import CloudIcon from '@mui/icons-material/Cloud';

export default function GlobalMetrics({metrics, currencySymbol}) {
  const { t } = useTranslation();

  return (
    <Card>
      <CardContent>
          <Stack spacing={2}>
              <Typography component="h2" variant="h6" color="primary">
                  {t("Total savings")}
              </Typography>
              <Grid container spacing={2} justifyContent={"center"}>
                  <Grid item xs={12} md={4}>
                      <Stack direction={"row"} alignItems={"center"} justifyContent={"center"} spacing={2}>
                          <PaymentsIcon style={{ fontSize: "40pt" }}/>
                          <Stack alignItems={"center"} spacing={1}>
                              <Typography variant="h4">
                                  {currencySymbol} {metrics.cost?.toLocaleString(undefined, {maximumFractionDigits: 0}) || "0"}
                              </Typography>
                              <Typography variant="h5">
                                  [ {metrics.costPercent?.toLocaleString(undefined, {maximumFractionDigits: 0}) || "0"} % ]
                              </Typography>
                          </Stack>
                      </Stack>
                  </Grid>
                  <Grid item xs={12} md={4}>
                      <Stack direction={"row"} alignItems={"center"} justifyContent={"center"} spacing={2}>
                          <Box sx={{ position: "relative", display: "inline-flex" }}>
                              <CloudIcon style={{ fontSize: "40pt" }} />
                              <Co2Icon
                                  style={{ fontSize: "30pt" }}
                                  sx={{
                                      position: "absolute",
                                      top: 7,
                                      left: 7,
                                      color: "white",
                                  }}
                              />
                          </Box>
                          <Stack alignItems={"center"} spacing={1}>
                              <Typography variant="h4">
                                  {metrics.co2?.toLocaleString(undefined, {maximumFractionDigits: 0}) || "0"} kg
                              </Typography>
                              <Typography variant="h5">
                                  [ {metrics.co2Percent?.toLocaleString(undefined, {maximumFractionDigits: 0}) || "0"} % ]
                              </Typography>
                          </Stack>
                      </Stack>
                  </Grid>

                  <Grid item xs={12} md={4}>
                      <Stack direction={"row"} alignItems={"center"} justifyContent={"center"} spacing={2}>
                          <BoltIcon style={{ fontSize: "40pt" }}/>
                          <Stack alignItems={"center"} spacing={1}>
                              <Typography variant="h4">
                                  {metrics.kwh?.toLocaleString(undefined, {maximumFractionDigits: 0}) || "0"} kWh
                              </Typography>
                              <Typography variant="h5">
                                  [ {metrics.kwhPercent?.toLocaleString(undefined, {maximumFractionDigits: 0}) || "0"} % ]
                              </Typography>
                          </Stack>
                      </Stack>
                  </Grid>
              </Grid>
          </Stack>

      </CardContent>
    </Card>
  );
}
